<div class="flip-container" [class.open]="show">
	<div class="flipper">
		<div id="front-card" class="front no-print">
			<div class="co2info" (click)="show = !show">
				<i class="icon-co2"></i>
				<p [innerHTML]="teaser | translate: placeholder"></p>
				<button type="button" [tabindex]="show ? -1 : 0" aria-controls="front-card back-card" [attr.aria-hidden]="show" [attr.aria-label]="'arialabel.more' | translate"><span>{{'flipper.more' | translate }} <i class="icon-chevron-down"></i></span></button>
			</div>
		</div>
		<div id="back-card" class="back show-print">
			<div class="co2info" (click)="show = !show" >
				<i class="icon-co2"></i>
				<p [innerHTML]="text | translate: placeholder"></p>
				<button class="no-print" [tabindex]="!show ? -1 : 0" aria-controls="front-card back-card" type="button" [attr.aria-hidden]="!show" [attr.aria-label]="'arialabel.close' | translate"   ><i class="icon-x"></i></button>
			</div>
		</div>
	</div>
</div>
